import doNothingImg from '../../images/kanban/do-nothing.svg'
import fridgeImg from '../../images/kanban/fridge.svg'
import toSortImg from '../../images/kanban/to-sort.svg'
import toRethinkImg from '../../images/kanban/to-rethink.svg'
import toCreateImg from '../../images/kanban/action-to-create.svg'

const DO_NOTHING_STATE = "DoNothing";
const FRIDGE_STATE = "fridge";
const TO_SORT_STATE = "toSort";
const TO_RETHINK_STATE = "toRethink";
const TO_CREATE_STATE = "toCreate";

const kanbanPattern = {
    tasks: {},
    columns: {
        DoNothing: {
            id: DO_NOTHING_STATE,
            title: "Ne rien faire",
            tasksIds: [],
            img: doNothingImg,

        },
        fridge: {
            id: FRIDGE_STATE,
            title: "Frigo",
            tasksIds: [],
            img: fridgeImg,

        },
        toSort: {
            id: TO_SORT_STATE,
            title: "À trier",
            tasksIds: [],
            img: toSortImg,

        },
        toRethink: {
            id: TO_RETHINK_STATE,
            title: "À repenser",
            tasksIds: [],
            img: toRethinkImg,

        },
        toCreate: {
            id: TO_CREATE_STATE,
            title: "Actions à créer",
            tasksIds: [],
            img: toCreateImg,

        },
    },
    columnOrder: [TO_SORT_STATE, TO_CREATE_STATE,  FRIDGE_STATE, TO_RETHINK_STATE, DO_NOTHING_STATE]
}
export default kanbanPattern